import { SaleOrder } from "./sale-order";
import { SystemField } from "./system-field";

export class FloorTable extends SystemField { 
     floor_level?:string;
     table_name?:string;
     status?:string;

     active_orders?:SaleOrder[];
}
